import AvgTicketHelper from 'src/components/GrossesHeader/AvgTicketHelper';
import PastMonthsHelper from 'src/components/GrossesHeader/PastMonthsHelper';
import GrossCombinedHelper from 'src/components/GrossesHeader/GrossCombinedHelper';

export default [
    {
        title: 'Show',
        subTitle: 'Theater',
        sortCol: 'show.sort_name',
        key: 'show_name',
        cssClasses: ['cell-medium'],
    },
    {
        title: 'Type',
        sortCol: ['show.type', 'show.name'],
        key: 'show_type',
    },
    {
        title: 'Week #',
        sortCol: 'week.number',
        key: 'week_number',
        cssClasses: ['cell-small'],
    },
    {
        title: 'End Date',
        sortCol: 'week.end',
        key: 'week_end',
        defaultSort: 'desc',
    },
    {
        title: 'Gross',
        subTitle: 'Potential Gross',
        sortCol: 'gross',
        defaultSort: 'desc',
        key: 'gross',
    },
    {
        title: 'Gross',
        sortCol: 'gross',
        defaultSort: 'desc',
        key: 'gross_combined',
        helper: GrossCombinedHelper,
    },
    {
        title: 'Gross Pot. %',
        sortCol: 'gross_potential_percentage',
        defaultSort: 'desc',
        key: 'gross_potential_percentage',
        cssClasses: ['cell-small'],
    },
    {
        title: 'Gross vs LW Diff',
        sortCol: 'diff_revenue_last_week',
        defaultSort: 'desc',
        key: 'diff_revenue_last_week',
    },
    {
        title: 'Attendance vs LW Diff',
        sortCol: 'diff_attendance_last_week',
        defaultSort: 'desc',
        key: 'diff_attendance_last_week',
    },
    {
        title: 'Capacity %',
        sortCol: 'capacity_percentage',
        key: 'capacity_percentage',
        defaultSort: 'desc',
        cssClasses: ['cell-small'],
    },
    {
        title: 'Attendance',
        sortCol: 'total_attendance',
        defaultSort: 'desc',
        key: 'attendance_combined',
        helper: GrossCombinedHelper,
    },
    {
        title: 'Attendance',
        subTitle: 'Capacity',
        sortCol: 'total_attendance',
        defaultSort: 'desc',
        key: 'attendance',
        cssClasses: ['cell-small'],
    },
    {
        title: 'Min. Ticket',
        sortCol: 'ticket_min',
        key: 'ticket_min',
        defaultSort: 'desc',
        cssClasses: ['cell-small'],
    },
    {
        title: 'Avg. Ticket',
        subTitle: 'Range/Top',
        sortCol: 'ticket_average',
        key: 'ticket_average',
        defaultSort: 'desc',
        helper: AvgTicketHelper,
    },
    {
        title: 'Max. Ticket',
        sortCol: 'ticket_max',
        key: 'ticket_max',
        defaultSort: 'desc',
        cssClasses: ['cell-small'],
    },
    {
        title: 'Top Premium',
        sortCol: 'ticket_top',
        key: 'ticket_top',
        defaultSort: 'desc',
        cssClasses: ['cell-small'],
    },
    {
        title: 'Perf.',
        subTitle: 'Previews',
        sortCol: 'performances',
        key: 'performances',
        cssClasses: ['cell-small'],
    },
    {
        title: '3 Months',
        sortCol: false,
        key: 'past_months',
        helper: PastMonthsHelper,
        cssClasses: ['cell-small'],
    },
];
